import { validateServerData } from '@wwt/core/admin'
import { ReservationDto } from '@wwt/entities/api/search-response'

import { api } from '@/shared/api/client'
import * as Errors from '@/shared/lib/errors'

export const getReservationQuery = async (
	offerId: string,
	signal: AbortSignal
) => {
	const response = await api()
		.options({ signal })
		.get(`/v1/reservation/${offerId}`)
		.notFound(error => {
			throw new Errors.NotFoundError('Not found', error.json)
		})
		.json()

	return await validateServerData(response, ReservationDto, 'Get reservation')
}
